var map = {
	"./basic/assets/languages/hk.json": 23596,
	"./cmbi/assets/languages/hk.json": 14459,
	"./eif/assets/languages/hk.json": 81586,
	"./fubon/assets/languages/hk.json": 92530,
	"./scb/assets/languages/hk.json": 17618,
	"./ttl/assets/languages/hk.json": 70862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99301;